import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const HistoryComponent = ({ image, year, description, alt, title}) => (
  <Col sm={6} lg={3} className="px-4 mb-5">
    <div className="text-center">
      <img src={image} alt={alt}></img>
    </div>
    <h4>
      <strong>{year}</strong>
    </h4>
    <h4>
      <strong>{title}</strong>
    </h4>
    <p>{description}</p>
  </Col>
);


HistoryComponent.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  year: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default HistoryComponent;